var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.071,
    height: 25.391,
    viewBox: "0 0 23.071 25.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(-813.697 1102.861) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M1087.94,814.794v2.259a3.914,3.914,0,0,0,0,7.552v11.059a1.1,1.1,0,0,0,2.2,0V824.634a3.914,3.914,0,0,0,0-7.552v-2.259a1.1,1.1,0,0,0-1.1-1.1A1.054,1.054,0,0,0,1087.94,814.794Zm2.885,6.035a1.79,1.79,0,0,1-1.785,1.784,1.784,1.784,0,0,1,0-3.567A1.79,1.79,0,0,1,1090.824,820.828Z",
    transform: "translate(1.126 0.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M1082.555,835.668v-2.349a3.914,3.914,0,0,0,0-7.552V814.8a1.1,1.1,0,0,0-1.1-1.1,1.079,1.079,0,0,0-1.1,1.1v10.97a3.914,3.914,0,0,0,0,7.552v2.349a1.1,1.1,0,0,0,1.1,1.1A1.079,1.079,0,0,0,1082.555,835.668Zm-2.884-6.125a1.789,1.789,0,0,1,1.783-1.783,1.752,1.752,0,0,1,1.784,1.783,1.789,1.789,0,0,1-1.784,1.785A1.828,1.828,0,0,1,1079.671,829.543Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M1095.526,814.8v10.97a3.914,3.914,0,0,0,0,7.552v2.349a1.1,1.1,0,0,0,1.1,1.1,1.079,1.079,0,0,0,1.1-1.1v-2.349a3.914,3.914,0,0,0,0-7.552V814.8a1.1,1.1,0,0,0-1.1-1.1A1.079,1.079,0,0,0,1095.526,814.8Zm2.884,14.746a1.789,1.789,0,0,1-1.783,1.785,1.784,1.784,0,1,1,0-3.568A1.789,1.789,0,0,1,1098.409,829.543Z",
    transform: "translate(2.252 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.d9c71691fa9d406a34236be615b5e8d0.svg";
export { ForwardRef as ReactComponent };